/**
 * QRMaps Design System - Theme Provider
 *
 * Shares Mantine defaults and a dialog stack across the app, while retaining
 * props.theme for existing styled-components layouts.
 */

import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { theme } from './theme';
import ScreenProvider from './mantine/ScreenProvider';

export const ThemeProvider = ({ children }) => {
  return (
    <StyledThemeProvider theme={theme}>
      <ScreenProvider>{children}</ScreenProvider>
    </StyledThemeProvider>
  );
};

export default ThemeProvider;